// create plan form 25/1/2024
import React, { useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import axios from "axios";
import app from "../Firebase";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import Constant from "../Components/Utils/Constant";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar";
import ReactPaginate from "react-paginate";
import EditHelpForm from "../Components/models/EditHelpForm";

export default function UploadHelp({ onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [client_name, setClient_name] = useState("");
  const [choose_file, setChoose_file] = useState(undefined);
  const [web_link, setWeb_link] = useState("");
  const [inputs, setInputs] = useState({});
  const [choose_filperc, setChoose_filePerc] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [affiliate, setAffiliate] = useState([]);
  const [dropdownStates, setDropdownStates] = useState([]);
  const tableRef = React.createRef();
  const [createPopup, setCreatePopup] = useState(false);
  const [data, setData] = useState([]);
  const [deletePopup, setDeletePopup] = useState("");
  const [editPopup, setEditPopup] = useState(false)

  const fetchData = async () => {
    try {
      const response = await fetch(`${Constant.BASE_URL}/help/get`);
      const data = await response.json();
      if (data) {
        setData(data);
      } else {
        console.error("Error fetching Help");
      }
    } catch (error) {
      console.error("Error fetching affiliate:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [deletePopup, createPopup, editPopup]);

  // upload choose file started
  useEffect(() => {
    choose_file && uploadFile(choose_file, "choose_fileUrl");
  }, [choose_file]);

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    let folder;

    if (fileType === "choose_fileUrl") {
      folder = "choose_file/";
    }

    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (fileType === "choose_fileUrl") {
          setChoose_filePerc(Math.round(progress));
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => {
            return {
              ...prev,
              [fileType]: downloadURL,
            };
          });
        });
      }
    );
  };
  console.log(deletePopup)

  const handleDelete = async () => {
    try {
      console.log("meow", deletePopup)
      const response = await axios.delete(
        `${Constant.BASE_URL}/help/delete/${deletePopup}`
      );
      if (response.status === 200) {
        toast.success("Help deleted Successfully");
        setTimeout(() => {
          setDeletePopup("");
        }, 2000);
      } else {
        console.log("Failed to delete the Help:", response.status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const adsData = {
        choose_file: inputs.choose_fileUrl,
        file_name: choose_file.name,
        client_name,
        web_link,
      };
      const response = await axios.post(
        `${Constant.BASE_URL}/help/upload`,
        adsData
      );
      if (response.status === 201) {
        setChoose_file(undefined);
        setClient_name("");
        setWeb_link("");
        toast.success("Help Uploaded successfully");

        setTimeout(() => {
          setCreatePopup(false);
        }, 3000);
      } else {
        console.log("Failed to submit form. Status:", response.status);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return isVisible ? (
    <>
      <Sidebar>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="p-3 overflow-auto bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            className="bg-white h-[78.55vh] "
            style={{ borderRadius: "0px 0px 11px 11px" }}
          >
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3 ">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div className="flex items-center justify-center border border-white rounded-sm cursor-pointer ">
                      <div className="text-4lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-bold">
                        <p>App Help</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Third Box */}
              <div className="flex-1">
                <div className="flex justify-end">
                  <div
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                    }}
                    className="lg:w-fit px-2  2xl:px-3 cursor-pointer flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] "
                  >
                    <div
                      onClick={() => {
                        setCreatePopup(true);
                      }}
                      className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] px-2 py-1 font-semibold"
                    >
                      {" "}
                      <p>Add file</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:h-[68vh] xl:h-[68vh] 2xl:h-[66vh] overflow-auto lg:w-[900px] xl:w-[1410px] 2xl:w-[2400px] ">
              {data &&
                data.map((item, i) => (
                  <div
                    className="w-full   border-gray-300 border-t-[1px] flex flex-row justify-between items-center px-4 py-3"
                    key={i}
                  >
                    <div onClick={() => { setEditPopup(item) }} className="flex flex-row items-center gap-5 cursor-pointer">
                      <div className="text-lg font-semibold">{i + 1}.</div>
                      <div className="border-b-[1px] pb-1 xl:w-72 lg:w-44 2xl:w-[500px] 2xl:text-2xl text-center  border-gray-300 text-black flex-none">
                        {item.client_name}
                      </div>
                      <div className="border-b-[1px] pb-1 xl:w-72 lg:w-44 2xl:w-[500px] 2xl:text-2xl text-center  border-gray-300 text-black flex-none">
                        {item.file_name.length > 5
                          ? item.file_name.substring(0, 5) + "..."
                          : item.file_name}
                      </div>
                      <div className="lg:ml-5 xl:ml-20 2xl:ml-[200px] text-center shadow-md text-black flex-none rounded-sm">
                        <p className="h-24 w-40 2xl:h-28 2xl:w-48 rounded-lg relative overflow-hidden">
                          <img src={item.choose_file} alt="helpimg" className="hover:scale-105 transition-transform duration-300 absolute inset-0 w-full h-full object-cover" />
                        </p>
                      </div>
                    </div>

                    <div
                      onClick={() => setDeletePopup(item._id)}
                      className=" xl:h-10 xl:px-5 lg:px-2 lg:h-6 lg:text-sm flex items-center xl:text-lg font-semibold bg-red-500 rounded-lg cursor-pointer w-fit"
                    >
                      Delete
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {createPopup && (
          <div className="popup-form">
            <div className="flex items-center justify-center w-full">
              <div className="p-4 px-2 py-3 bg-white rounded-md shadow-md lg:py-3 xl:py-3 2xl:p-4 ">
                <div className="lg:w-[300px] xl:w-[320px] 2xl:w-[420px] items-center justify-center">
                  <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                    Create Help
                  </div>
                  <hr className="mt-1 " />

                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col items-center justify-center ">
                      <div className="lg:py-5 xl:py-7 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                        <div className="flex items-center justify-end py-3">
                          <label
                            htmlFor="yourInput"
                            className="flex flex-row items-end flex-none px-3"
                          >
                            Thumbnail :
                            <span className="ml-1 text-red-500">*</span>
                          </label>
                          <div className="flex items-center lg:w-[180px] xl:w-[200px] 2xl:w-[250px]">
                            <label
                              htmlFor="choose_file"
                              className="flex items-center justify-center w-full mb-2 text-center text-gray-400 border-b border-gray-500 outline-none cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap"
                            >
                              {choose_file
                                ? choose_file.name.length > 15
                                  ? choose_file.name.substring(0, 15) + "..."
                                  : choose_file.name
                                : "Upload File"}{" "}
                            </label>
                            <input
                              type="file"
                              id="choose_file"
                              name="choose_file"
                              className="hidden"
                              onChange={(e) =>
                                setChoose_file(e.target.files[0])
                              }
                              required
                            />

                          </div>

                          <div
                            className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                            style={{ width: `${choose_filperc}%` }}
                          ></div>
                        </div>
                        <div className="flex items-center justify-end py-3">
                          <label
                            htmlFor="yourInput"
                            className="flex items-end px-3"
                          >
                            Video Title:
                            <span className="ml-1 text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="cleient_name"
                            name="cleient_name"
                            className="flex items-start mb-2 border-b border-gray-500 outline-none lg:w-[180px] xl:w-[200px] 2xl:w-[250px] text-center"
                            placeholder="Client Name"
                            value={client_name}
                            onChange={(e) => setClient_name(e.target.value)}
                            required
                          />
                        </div>

                        <div className="flex items-center justify-end py-3">
                          <label
                            htmlFor="yourInput"
                            className="flex items-end px-3"
                          >
                            Video Link:
                            <span className="ml-1 text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="web_link"
                            name="web_link"
                            className="flex items-start mb-2 border-b border-gray-500 outline-none lg:w-[180px] xl:w-[200px] 2xl:w-[250px] text-center"
                            placeholder="Web Link"
                            value={web_link}
                            onChange={(e) => setWeb_link(e.target.value)}
                            required
                          />
                        </div>

                      </div>
                      <div
                        className=" py-4 button-container flex justify-center p-1 space-x-12 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setCreatePopup(false);
                          }}
                          className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                          style={{
                            boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="flex-shrink-0 px-3 py-1 rounded-sm"
                          style={{
                            background:
                              "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                          }}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}


        {deletePopup && (
          <div className="pop-delete">
            <div className="flex items-center justify-center w-full">
              <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                <div className="lg:w-[300px] xl:w-[320px] 2xl:w-[520px] items-center justify-center">
                  <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                    Are you sure want to delete this Help?
                  </div>

                  <hr className="p-2 mt-1" />
                  <div className="flex flex-col items-center justify-center py-5">
                    <button
                      type="button"
                      onClick={() => setDeletePopup("")}
                      className="flex-shrink-0 w-16 bg-white shadow-md text rounded-sm"
                      style={{
                        boxShadow:
                          "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      No
                    </button>

                    <button
                      onClick={handleDelete}
                      className="flex-shrink-0 w-16 mt-5 text-white text bg-custom-gradient rounded-sm"
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {editPopup && (<EditHelpForm editPopup={editPopup} setEditPopup={setEditPopup} />)}
      </Sidebar>
    </>
  ) : null;
}